<div class="drawer">
    <input #sidenavToggle id="hamburgerMenu" type="checkbox" class="drawer-toggle" />
    <div class="drawer-content flex flex-col">
        <!-- Navbar -->
        <app-header [name]="name" [role]="role" [url]="url"></app-header>

        <!-- Page content here -->
        <main class="p-4 h-[92dvh] overflow-auto max-w-(--breakpoint-2xl) w-full mx-auto">

            <router-outlet></router-outlet>

        </main>
        <app-toast />
        <app-session-timeout-modal />
    </div>
    <div class="drawer-side">
        <label for="hamburgerMenu" aria-label="close sidebar" class="drawer-overlay"></label>

        <app-sidenav [name]="name" [role]="role" [url]="url" [closeSidenav]="closeSidenav.bind(this)"></app-sidenav>
        <!-- 
                This section of the layout.component.html file contains a commented-out reference to the JavaScript .bind(this) method.
                The .bind(this) method is typically used in JavaScript to ensure that the 'this' keyword inside a function refers to the desired context, 
                often the current class or component instance. In Angular templates, explicit use of .bind(this) is uncommon, as Angular handles context binding automatically.
                The comment may indicate a previous or considered approach to event binding or function referencing that is not required in the current Angular template.
                If you want to utilize something in the parent component and in the method you use instances of the parent component, you can use the .bind(this) method to ensure that the context of 'this' refers to the parent component instance.
            -->
    </div>
</div>